<template>
    <!-- <div class="form-login content-div">

        <h1 class="modal-title fs-5 mb-3">
            Mot de passe oublié
        </h1>

        <div class="field mb-3">
            <label class="form-label">Adresse mail</label>
            <div class="control">
                <input type="email" class="form-control" name="" id="" v-model="email">
            </div>
            <p class="help is-danger">{{email_error}}</p>
        </div>
        <div class="form-text mb-3">
            Pour vous connecter <span class="has-text-info is-clickable" @click="$emit('showSignIn')"> cliquez ici</span>
            <h6 class="">Pour vous connecter <a @click="$emit('showSignIn')" href="#">Cliquez ici</a></h6>
        </div>

        <div class="buttons mt-5 is-justify-content-center mb-3">
            <button type="btn-forgotten-pwd" class="btn-primary1" @click="send">
                Envoyer
            </button>
        </div>

    </div> -->
    <div class="modal-overlay">
        <div class="modal-content">
            <button @click="$emit('showSignIn')" style="position: absolute; top: 10px; right: 10px; background: transparent; border: none; font-size: 1.5rem; cursor: pointer;">×</button>
            <div class="forgot-pwd-content">
                <h1 class="modal-title fs-5 mb-3">Mot de passe oublié</h1>

                <div class="field mb-3">
                <label class="form-label">Adresse mail</label>
                <div class="control">
                    <input type="email" class="form-control" v-model="email" />
                </div>
                <p class="help is-danger">{{ email_error }}</p>
                </div>

                <div class="form-text mb-3">
                <h6 style="text-align: right;">Pour vous connecter <a @click="$emit('showSignIn')" href="#">Cliquez ici</a></h6>
                </div>

                <div class="buttons mt-4 is-justify-content-center mb-3">
                <button type="btn-forgotten-pwd" class="btn-primary1" @click="send">Envoyer</button>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import axios from 'axios'
import { toast } from 'bulma-toast'
export default {
    name: 'ForgottenPassword',
    data () {
        return {
            email: null,
            email_error: null
        }
    },
    methods: {
        send () {
            const mail_reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!mail_reg.test(String(this.email).toLowerCase())) {
                this.email_error = "L'adresse mail est incorrecte."
                return false
            }
            this.email_error = null
            axios.post('/forgot-password', {email: this.email}).then(response => {
                toast({
                    message: 'Un mail a été envoyé à l\'adresse email indiquée afin de réinitialiser le mot de passe.',
                    type: 'is-success',
                    duration: 5000,
                    pauseOnHover: true
                })
            })
        }
    }
}
</script>

<!-- <style>
    #btn-forgotten-pwd {
        background-color: var(--btn-primary-bg-color);
        color: var(--btn-primary-text-color);
    }

    #btn-forgotten-pwd:hover {
        background-color: var(--btn-primary-bg-color-hover);
        color: var(--btn-primary-text-color);
    }
</style> -->

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(128, 128, 128, 0.5); /* grey background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-content {
  background: white;
  border-radius: 10px; /* rounded corners */
  padding: 0.75rem 1rem;
  max-width: 700px;
  width: 100%;
}
.forgot-pwd-content {
    width: 85%;
    margin: 1rem auto;
}
</style>